<template>
    <div v-if="isLogged">
        <v-navigation-drawer
                v-model="drawer"
                :mini-variant="mini"
                absolute
                clipped
                fixed
                app
        >
            <v-list class="pa-1">
                <v-list-tile v-if="mini" @click.stop="mini = !mini">
                    <v-list-tile-action>
                        <v-icon>chevron_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-list-tile avatar tag="div">
                    <v-list-tile-avatar>
                        <img src="https://lemonconcentrate.com/wp-content/uploads/2017/08/logo_lc.png">
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title v-if="user">{{ user.name }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn icon @click.stop="mini = !mini">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>

            <v-list class="pt-0">

                <ClientMenu v-if="rol == 'Client'"></ClientMenu>

                <AdminMenu v-if="rol == 'Admin'"></AdminMenu>

                <AgentMenu v-if="rol == 'Agent'"></AgentMenu>

                <FtnMenu v-if="rol == 'AMC'"></FtnMenu>

            </v-list>
        </v-navigation-drawer>
        <v-toolbar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                color="primary"
                dark
                app
                fixed
        >
            <v-toolbar-title style="width: 325px" class="ml-0 pl-3">
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <span class="hidden-sm-and-down">Lemon Concentrate Gestor</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <ChangeUser v-if="rol == 'Agent'"></ChangeUser>
            <v-spacer></v-spacer>
            <NotificationComponent></NotificationComponent>
            <v-menu offset-y>
                <v-btn icon large slot="activator">
                    <v-avatar size="32px" tile>
                        <img
                                src="https://lemonconcentrate.com/wp-content/uploads/2017/08/logo_lc.png"
                                alt="Lemon"
                        >
                    </v-avatar>
                </v-btn>

                <v-list>
                    <v-list-tile
                            :to="{ name: 'profile'}"
                    >
                        <v-list-tile-title><v-icon color="primary">account_circle</v-icon>  My profile</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                            @click="logout"
                    >
                        <v-list-tile-title><v-icon color="primary">exit_to_app</v-icon>  Logout</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
    </div>


</template>

<script>
    import ClientMenu from './menu/ClientMenu';
    import AdminMenu from './menu/AdminMenu';
    import AgentMenu from './menu/AgentMenu';
    import ChangeUser from './ChangeUser';
    import FtnMenu from './menu/FtnMenu';
    import NotificationComponent from './components/NotificationComponent';

    export default {
        data: () => ({
            drawer: null,
            mini: false
        }),
        computed : {
            isLogged : function(){
                return this.$store.getters.isLogged;
            },
            rol: function() {
                return this.$store.getters.getRole;
            },
            user: function() {
                return this.$store.getters.getUser;
            }
        },
        created () {
            if (this.$store.getters.getRole == 'AMC') {
                this.mini = true;
            }
        },
        methods :  {
            logout() {
                this.$store.dispatch('logout').then((res) => {

                    this.$router.push({ name : 'login'});

                }).catch((error) => {
                    //if incorrect we show a message

                });
            }
        },
        components : {
            ClientMenu,
            AdminMenu,
            AgentMenu,
            ChangeUser,
            FtnMenu,
            NotificationComponent
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/HeaderComponent.vue